import moment from "moment";
import CreatePresetContentCard from "./CreatePresetContentCard";
import { useNavigate } from "react-router-dom";
import { ContentType } from "../../constants/ContentType";
import { setNewContent } from "../../store/contentSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../helpers/hooks";
import { INewContent } from "../../models/NewContent";
import CustomRightArrow from "./CustomRightArrow";
import CustomLeftArrow from "./CustomLeftArrow";
import { Carousel } from "antd";
import { useWindowSize } from "@uidotdev/usehooks";
import { AICreateTabs } from "../../helpers/Utils";

function ContentAvatar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lastSelectedBrandId = useAppSelector(
    (k) => k.persisted.lastSelectedBrandId
  );
  const newContent = useAppSelector((k) => k.content.newContent);
  const size = useWindowSize();


  const isMobile = () => {
    return size.width && size.width <= 500;
  };


  return (
    <div className="flex-col w-full h-full mt-2">
      <div className="flex-col w-[1050px]">
        <Carousel
          slidesToShow={isMobile() ? 1 : 6}
          nextArrow={<CustomRightArrow />}
          prevArrow={<CustomLeftArrow />}
          dots={false}
        >
          <CreatePresetContentCard
            onClick={() => {
              dispatch(
                setNewContent({
                  ...newContent,
                  sliderCount: 1,
                  contentType: ContentType.video,
                  loopName: `Loop_${moment().format("DD_MM_yyyy_hh_mm")}`,
                  brand: { id: lastSelectedBrandId },
                } as INewContent)
              );
              navigate(`/editor?type=${AICreateTabs.AVATAR}`);
              // dispatch(toggleContentWizard());
            }}
            title="Avatar"
            sampleImagePath="content-avatar-avatar.png"
          />
          {/*This div is a placeholder for other  CreatePresetContentCard to align*/}

        </Carousel>
      </div>

    </div>
  );
}

export default ContentAvatar;
